import React, { useState } from "react";
import axios from "axios";
import "../Styles/AddFestival.css";

function AddFestival({ refreshDashboard }) {

  const [festival, setFestival] = useState({
    name: "",
    date: "",
    description: ""
  });

  const [image, setImage] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFestival({
      ...festival,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!festival.name || !festival.date) {
      setError("Please enter festival name and date.");
      return;
    }

    try {

      const formData = new FormData();

      formData.append("name", festival.name);
      formData.append("date", festival.date);
      formData.append("description", festival.description);

      if (image) {
        formData.append("file", image);
      }

      await axios.post(
        "http://localhost:8080/api/festivals/upload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMessage("Festival added successfully.");

      setFestival({
        name: "",
        date: "",
        description: ""
      });

      setImage(null);

      document.getElementById("festivalImage").value = "";

      if (refreshDashboard) {
        refreshDashboard();
      }

    } catch (err) {

      console.error(err);

      setError(
        err.response?.data ||
        "Failed to add festival."
      );
    }
  };

  return (
    <div className="add-festival-page">

      <h2>Add Festival</h2>

      <form onSubmit={handleSubmit}>

        <div className="festival-field">

          <label>Festival Name</label>

          <input
            type="text"
            name="name"
            value={festival.name}
            onChange={handleChange}
            placeholder="Enter festival name"
          />

        </div>


        <div className="festival-field">

          <label>Date</label>

          <input
            type="date"
            name="date"
            value={festival.date}
            onChange={handleChange}
          />

        </div>


        <div className="festival-field">

          <label>Description</label>

          <textarea
            name="description"
            value={festival.description}
            onChange={handleChange}
            placeholder="Enter festival description"
            rows="5"
          />

        </div>


        <div className="festival-field">

          <label>Festival Image</label>

          <input
            id="festivalImage"
            type="file"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />

        </div>


        <button type="submit">
          Add Festival
        </button>

      </form>


      {message && (
        <p className="festival-success">
          {message}
        </p>
      )}

      {error && (
        <p className="festival-error">
          {error}
        </p>
      )}

    </div>
  );
}

export default AddFestival;